import { useInvoiceAlertsData } from '@features/invoices/contexts/alerts/useInvoiceAlertsData';
import { TilesCarousel } from '@shared/components/tiles-carousel/TilesCarousel';
import * as React from 'react';

import type { InvoiceAlertTilesProps } from './InvoiceAlertTiles.types';

import { InvoiceAlertTile } from '../alert-tile/InvoiceAlertTile';
import {
  formatInvoiceAmount,
  sortAlerts,
} from '../alert-tiles/InvoiceAlertTiles.utils';
import { LookingToPayInvoicesTile } from '../looking-to-pay-invoices-tile/LookingToPayInvoicesTile';
import styles from './InvoiceAlertTiles.module.css';

const InvoiceAlertTiles = React.memo(
  ({ alerts }: Readonly<InvoiceAlertTilesProps>): React.ReactElement => {
    const { openAlertPanel } = useInvoiceAlertsData();
    const sortedAlerts = React.useMemo(() => sortAlerts(alerts), [alerts]);

    return (
      <section
        data-testid="invoice-alert-tiles"
        className={styles.tilesSection}
      >
        <TilesCarousel
          scrollContainerClassName={styles.invoiceAlertTilesCarousel}
        >
          {[
            <LookingToPayInvoicesTile key="looking-to-pay" />,
            ...(sortedAlerts.length > 0
              ? sortedAlerts.map(alert => (
                  <InvoiceAlertTile
                    key={`${alert.priorityType}-${alert.currency}`}
                    amount={formatInvoiceAmount(alert.totalAmount)}
                    currency={alert.currency}
                    priorityType={alert.priorityType}
                    invoiceCount={alert.numberOfInvoices}
                    onClick={() => openAlertPanel(alert)}
                  />
                ))
              : []),
          ]}
        </TilesCarousel>
      </section>
    );
  }
);

InvoiceAlertTiles.displayName = 'InvoiceAlertTiles';
export { InvoiceAlertTiles };
